module.exports = __webpack_public_path__ + "img/background_9.f89a46bb.jpg";